import { render } from "./WidgetsPanel.vue?vue&type=template&id=32901976&scoped=true"
import script from "./WidgetsPanel.vue?vue&type=script&lang=ts"
export * from "./WidgetsPanel.vue?vue&type=script&lang=ts"

import "./WidgetsPanel.vue?vue&type=style&index=0&id=32901976&lang=scss&scoped=true"
import "./WidgetsPanel.vue?vue&type=style&index=1&id=32901976&lang=scss"
script.render = render
script.__scopeId = "data-v-32901976"

export default script